import React, { useState } from "react";
import { Alert, Box, Button, Checkbox, DialogActions, DialogContent, DialogTitle, Divider, IconButton, Modal, ModalDialog, Stack, Tooltip, Typography } from "@mui/joy";
import AddAlarmRoundedIcon from '@mui/icons-material/AddAlarmRounded';
import { formatDate, isValidDate } from "@utils/dates";
import ObjectPreview from "./objects/ObjectPreview";
import { AddTimeModal } from "./AddTimeModal";

export function Task(
    { task, displayNotes = false, displayWorkPlan = false }
    :
    { task: any; displayNotes?: boolean, displayWorkPlan?:boolean }
) {
    const [addTimeOpen, setAddTimeOpen] = useState(false);
    const dueDate = isValidDate(task.due_date) ? formatDate(task.due_date) : null;
    const isCompleted = task.completed_at && isValidDate(task.completed_at);

    return (<>
        <Stack
            direction="row"
            justifyContent="flex-start"
            alignItems="flex-start"
            spacing={2}
            /*
            sx={{
                textDecoration: isCompleted ? 'line-through' : 'normal',
            }}
            */
        >
            <Box>
                <Tooltip title={'Add Time to Task'}>
                    <IconButton
                        size="sm"
                        color="neutral"
                        variant="outlined"
                        onClick={()=>setAddTimeOpen(true )}
                        sx={theme => ({
                            bgcolor: 'background.surface',
                            /*
                            bgcolor: theme.palette[props.color ?? "neutral"][600],// 'background.surface'
                            color: '#fff',
                            */
                        })}
                        >
                        <AddAlarmRoundedIcon/>
                    </IconButton>
                </Tooltip>
            </Box>
            <Box fontSize={'md'}>
                <Typography>{task.task_name}</Typography>

                {displayWorkPlan === true && !!task?.workplan && (<>
                    <Box fontSize={'sm'}>
                        <Typography fontSize={'sm'} fontWeight={'bold'} sx={{display: 'inline'}}>Work Plan{` `}</Typography>
                        <ObjectPreview to={`/work-plans/${task.workplan.id}`} object={task.workplan}>{task.workplan.name}</ObjectPreview>
                    </Box>
                </>)}

                {!!task?.contacts && task.contacts.length > 0 && (<>
                    <Box fontSize={'sm'}>
                        <Typography fontSize={'sm'} fontWeight={'bold'} sx={{display: 'inline'}}>Assigned to{` `}</Typography>
                        {task.contacts.map((contact, contactIndex) => (<React.Fragment key={contactIndex}>
                            <ObjectPreview key={contact.id} to={`/contacts/${contact.id}`} object={contact}>{contact.name}</ObjectPreview>
                            {contactIndex < task.contacts.length - 1 && `, `}
                        </React.Fragment>))}
                    </Box>
                </>)}

                {displayNotes && task.notes && (
                    <Typography fontSize={'sm'}>{task.notes}</Typography>
                )}
            </Box>
        </Stack>
        <AddTimeModal
          open={addTimeOpen}
          setOpen={setAddTimeOpen}
          task={task}
        />
    </>);
}
